// extracted by mini-css-extract-plugin
export var badge = "_vr-4";
export var selected = "_vr-1";
export var selectedOverlay = "_vr-5";
export var thumbnailButton = "_vr-0";
export var thumbnailFallback = "_vr-3";
export var thumbnailImage = "_vr-2";